import {
    AfterContentChecked,
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ChangeDetectorRef
} from '@angular/core';
import {
    MenuItemsInterface,
    SidebarNavService
} from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-sidebar-nav',
    templateUrl: './sidebar-nav.component.html',
})
export class SidebarNavComponent implements OnInit, AfterViewInit, OnDestroy, AfterContentChecked {

    @Input() navService: SidebarNavService = undefined;
    @Input() themeName: string = 'stepper';
    @Output() updatedActiveItem: EventEmitter<any> = new EventEmitter<any>();

    subscription: Subscription;

    stepHeader = 'Step';
    currentIndex:number;
    currentItem: MenuItemsInterface;
    currentStatus:string;
    menuItems: Array<MenuItemsInterface>
    showProgressBar: boolean;
    totalProgress: number = 0;
    isViewInit: boolean = false;

    constructor(
        private changeDetector: ChangeDetectorRef,
    ) { }

    ngOnInit() {
        this.menuItems = this.navService.getMenuItems();
        this.showProgressBar = this.navService.showProgressBar();

        this.subscription = this.navService.triggerEvent$.subscribe({
            next: (event:any) => {
                const action = event['actionName'];
                if(action) {
                    delete event.actionName;
                }
                if(action === SidebarNavService.CONSTANTS['onCurrentActiveItem']) {
                    const {currentActiveItem, totalProgress} = event;
                    const currentItem:MenuItemsInterface = currentActiveItem;
                    this.totalProgress=totalProgress;
                    if(this.isViewInit) {
                        this.updatedActiveItem.emit(currentActiveItem);
                    }
                    this.currentItem = currentItem;
                }
            }
        });
    }

    menuItemClick(index:number = undefined, groupId:any = undefined): void {
        if(this.currentIndex == index) {
            return;
        }
        let item: MenuItemsInterface;
        if(groupId == undefined) {
            item = this.menuItems[index];
        }
        else {
            const groupItems = this.navService.menuItemsGroup[groupId];
            item = groupItems[index]
        }
        if(item.status === 'pending') {
            return;
        }
        if(groupId) {
            this.navService.setActiveGroupItem(groupId, item.id);
        }
        else {
            this.navService.setActiveItem(item.id);
        }
    }

    ngAfterViewInit(): void {
        this.isViewInit=true;
        setTimeout( () => {this.navService.setActiveItem();},300)
    }

    ngOnDestroy(): void {
        if(this.subscription)
            this.subscription.unsubscribe();
    }

    ngAfterContentChecked(): void {
        this.changeDetector.detectChanges();
    }

}
